import React, { useRef, useEffect, useCallback, useState} from 'react';
import Caurosel from './Caurosel.js';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js";
import SporesView from './SporesView.js';
import {sleep} from 'utils/sleep.js';
import {useShader} from './sketch.js';
import StemPlayer from './StemPlayer.js';
import SimplePlayer from './SimplePlayer.js';
import ScriptableSequencerEngine from "engine/ScriptableSequencer.js"
import {connect} from 'react-redux';
import './spore.scss';

const Spore = (props) => { 
    let [playerChosen, setPlayerChosen] = useState(undefined);
    let [showStemPlayer, setShowStemPlayer] = useState(false);
    let [showSpores, setShowSpores] = useState(false);
    let [s, setS] = useState(false);
    let [sequencerEngine, setSequencerEngine] = useState();
    let [canvasBackground, setCanvasBackground]= useState();
    let ref = useRef();


    useEffect(() => {
        setShowSpores(false);
    }, [showStemPlayer, setShowSpores]);

    useEffect(() => {
        window.addEventListener("mousewheel", preventDefault, {passive: false});
        return () => window.removeEventListener("mousewheel", preventDefault);
    }, []);

    const preventDefault = (e) => e.preventDefault();

    useEffect(() => {
        var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
        root.setAttribute( 'class', 'bad-scroll' );
        document. title = "Spores"
    }, []);

    useShader(ref);

    let className = "spore";
    if (showStemPlayer) {
        className += " showing-spore-player";
    }
    if (showSpores) {
        className += " showing-spores";
    }
    return (
        <div ref={ref} className={className}>
          {<Caurosel showStemPlayer={showStemPlayer || showSpores}
                     setShowStemPlayer={(x) => {
                         setShowStemPlayer(x);
                         setShowSpores(x);
                     }}
                     playerChosen={playerChosen} setPlayerChosen={setPlayerChosen}/>}
          {(playerChosen && !showStemPlayer && showSpores) && <SporesView tokenId={playerChosen} setShowStemPlayer={setShowStemPlayer}/>}
          {playerChosen && !showSpores && (showStemPlayer ? <StemPlayer tokenId={playerChosen}/> : <SimplePlayer tokenId={playerChosen} setShowStemPlayer={setShowStemPlayer}/>)}
          {playerChosen && (showSpores || showStemPlayer) &&
           <div
             onClick={() => {
                 setShowStemPlayer(false);
                 setShowSpores(false);
             }}
             className="spore-button pushable stem-player-button">
             See Latest Spore
             <img className="spore-icon one-spore" src="/one-spore.svg"/>
           </div>}
          {playerChosen && !showSpores && !showStemPlayer &&
           <div
             onClick={() => setShowSpores(true)}
             className="spore-button pushable stem-player-button">
             See All Spores <img className="spore-icon" src="/spores-icon-glow2.svg"/>
           </div>}
        </div>
    );
};
          
const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Spore);
